<section class="flex flex-col w-full h-full min-w-460 min-h-256">
  @if (data.title) {
    <header>
      <h2 class="m-10 text-lg font-bold">{{data.title}}</h2>
    </header>
  }
  <section class="dialog-content">
    <!-- `whitespace-pre-line` so a message can be more than one paragraph: the SMA
         confirmation states what the strategy means, then asks. Collapses runs of spaces
         exactly as before, so single-line messages are unaffected. -->
    <p class="m-auto text-lg whitespace-pre-line">{{data.message}}</p>
    <!-- The question, when the dialog has one. Same size as the body -- this is emphasis, not a
         heading -- but heavier and darker, so the eye lands on what is actually being asked. -->
    @if (data.question) {
      <p class="m-auto mt-15 text-lg font-semibold whitespace-pre-line text-gray-darkest">{{data.question}}</p>
    }
  </section>
  <footer>
    @if (!data.hideCancelButton) {
      <button mat-button class="m-10 button is-mint is-outlined flex justify-center items-center min-w-128" [mat-dialog-close]="false">Cancel</button>
    }
    <button mat-button class="m-10 ml-auto button flex justify-center items-center min-w-128" [class]="data.isWarning ? 'is-warning' : 'is-mint'"
    [mat-dialog-close]="true">{{data.confirmationButtonText ? data.confirmationButtonText : 'Confirm'}}</button>
  </footer>
</section>